<script>
  import { getContext, onDestroy, onMount } from 'svelte'

  export let colspan = null

  let usedColspan = 1

  /**
   * This prevents an infinte loop caused by slot usage in combination
   * with an if statement (see DataTableExpansion.svelte).
   */
  let updateStateOnDestroy = false

  const colspanStore = getContext('dataTableColspanStore')
  const state = getContext('expansion')

  $: {
    if (!isNaN(colspan)) {
      usedColspan = colspan
    } else if (colspanStore) {
      usedColspan = $colspanStore
    }
  }

  onMount(() => {
    state.update(expansionState => {
      updateStateOnDestroy = expansionState
      return true
    })
  })

  onDestroy(() => {
    if (updateStateOnDestroy) state.set(false)
  })
</script>

<td colspan={usedColspan}>
  <div class="gl-table-expansion-body"><slot /></div>
</td>
